import React from 'react'
import { Card, CardContent, CardHeader, Label, Switch } from '@/shared/ui'
import { useToast } from '@/shared/ui/Toast'
import { getChristmasSnowEnabled, setChristmasSnowEnabled } from '../services/christmasSnowFeatureService'

export default function ChristmasSnowSettings() {
  const [loading, setLoading] = React.useState(true)
  const [saving, setSaving] = React.useState(false)
  const [enabled, setEnabled] = React.useState(false)
  const { add: toast } = useToast()

  React.useEffect(() => {
    let mounted = true
    getChristmasSnowEnabled()
      .then((on) => {
        if (mounted) setEnabled(on)
      })
      .catch((e) =>
        toast({
          title: 'Tema de Natal',
          description: e?.message || 'Falha ao carregar',
          variant: 'error',
        }),
      )
      .finally(() => {
        if (mounted) setLoading(false)
      })
    return () => {
      mounted = false
    }
  }, [])

  async function handleToggle(next: boolean) {
    if (saving) return
    setSaving(true)
    try {
      await setChristmasSnowEnabled(next)
      setEnabled(next)
      toast({
        title: 'Tema de Natal',
        description: next ? 'Neve ativada no sistema' : 'Neve desativada no sistema',
        variant: 'success',
        soft: true,
      })
    } catch (e: any) {
      toast({
        title: 'Tema de Natal',
        description: e?.message || 'Falha ao salvar',
        variant: 'error',
      })
    } finally {
      setSaving(false)
    }
  }

  return (
    <Card>
      <CardHeader className="text-base font-semibold">Tema de Natal (neve)</CardHeader>
      <CardContent>
        <div className="flex items-center justify-between gap-4 text-sm text-foreground/80">
          <div>
            <div>Ativa um efeito de neve no rodap�� do sistema com flocos caindo na tela.</div>
            <div className="mt-1 text-xs text-foreground/60">
              Configura����o global, controlada apenas pela role master em Configura����es Gerais.
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Label>Desligado</Label>
            <Switch
              checked={enabled}
              onChange={(e) => handleToggle((e.target as HTMLInputElement).checked)}
              disabled={loading || saving}
            />
            <Label>Ligado</Label>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

